import { render, staticRenderFns } from "./DeleteTagDialog.vue?vue&type=template&id=ef126d0c&"
import script from "./DeleteTagDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteTagDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports